<template>

    <div id="visual-line">
        <ul class="holder">
            <li>
                <div class="label">Размер шрифта</div>
                <ul id="visual-font-size">
                    <li class="n" v-on:click="setFontSizeChange('n')" v-bind:class="{'active' : fontSize == 'n'}">A</li>
                    <li class="b" data-class="font-size-b" v-on:click="setFontSizeChange('font-size-b')" v-bind:class="{'active' : fontSize == 'font-size-b'}">A</li>
                    <li class="vb" data-class="font-size-vb" v-on:click="setFontSizeChange('font-size-vb')" v-bind:class="{'active' : fontSize == 'font-size-vb'}">A</li>
                </ul>
            </li>
            <li>
                <div class="label">Изображения</div>
                <ul id="visual-images">
                    <li class="on" v-on:click="showImagesChange(true)" v-bind:class="{'active' : showImages}">Вкл</li>
                    <li class="off" data-class="images-off" v-on:click="showImagesChange(false)" v-bind:class="{'active' : !showImages}">Выкл</li>
                </ul>
            </li>
            <li>
                <div class="label">Цвет фона</div>
                <ul id="visual-color">
                    <li class="n" v-on:click="setFontColorChange('white')" v-bind:class="{'active' : fontColor == 'white'}"></li>
                    <li class="bw" data-class="color-bw" v-on:click="setFontColorChange('color-bw')" v-bind:class="{'active' : fontColor == 'color-bw'}"></li>
                    <li class="bg" data-class="color-bg" v-on:click="setFontColorChange('color-bg')" v-bind:class="{'active' : fontColor == 'color-bg'}"></li>
                </ul>
            </li>
        </ul>
    </div>
    
</template>

<script>
    export default {
        components: { },

        data: function () {
            return {
                showImages: true,
                fontColor: 'white',
                fontSize: 'n',

            }
        },

        created: function () {
            this.setVisuallyStyles();
        },


        methods: {

            setVisuallyStyles: function() {
                if (localStorage.getItem("showImages") != null) {
                    if (localStorage.getItem("showImages") == 'true') {
                        // $('body').removeClass('images-off');
                        this.showImages = true;
                    } else {
                        $('body').addClass('images-off');
                        this.showImages = false;
                    }
                }
                if (localStorage.getItem('fontColor') != null) {
                    if (localStorage.getItem('fontColor') == 'color-bw') {
                        $('body').addClass('color-bw');
                        this.fontColor = 'color-bw';
                    }
                    if (localStorage.getItem('fontColor') == 'color-bg') {
                        $('body').addClass('color-bg');
                        this.fontColor = 'color-bg';
                    }
                }

                if (localStorage.getItem('fontSize') != null) {
                    if (localStorage.getItem('fontSize') == 'font-size-b') {
                        $('body').addClass('font-size-b');
                        this.fontSize = 'font-size-b';
                    }
                    if (localStorage.getItem('fontSize') == 'font-size-vb') {
                        $('body').addClass('font-size-vb');
                        this.fontSize = 'font-size-vb';
                    }
                }
            },

            showImagesChange: function (status) {
                localStorage.setItem("showImages", status);
            },

            setFontColorChange: function (value) {
                localStorage.setItem('fontColor', value);
            },

            setFontSizeChange: function (value) {
                localStorage.setItem('fontSize', value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// VVisually.vue?3607d282